export default {"href":"/corgi/pageapps/purchase/_next/public/sprite-3.48.0-de48ae84e.svg#assortment-2","viewBox":"0 0 20 16"}